// extracted by mini-css-extract-plugin
export var wrap = "numeric-input-module--wrap--YeJTV";
export var input = "numeric-input-module--input--2GKub";
export var increment = "numeric-input-module--increment--3Q-Ag";
export var decrement = "numeric-input-module--decrement--3IRLW";